module.exports = {
  /* Start - Main schema validation */
  type: "object",
  optional: [],
  properties: {},
};
